<template>
  <v-layout row class="mb-4">
    <v-flex xs12 sm10 offset-sm1 lg10 offset-lg1 class="mt-5">
      <v-card>
        <v-progress-linear :indeterminate="true" height="4" v-if="busy" color="accent"   class="my-0"></v-progress-linear >
        <v-card-title primary-title class="grey lighten-4">
          <h3 class="headline mb-0">Betrieb verwalten</h3>
<v-spacer></v-spacer>

<span v-if="this.company">
           <v-btn
           flat 
           large
            v-if="BetriebVorhanden"
            :to="{name: 'showCompany', params: {id: this.company.slug}}"
          >Profil ansehen</v-btn>

         
          </span>
          <span v-else>
            <v-btn @click="CheckBetrieb()" icon flat> 
              <v-icon>refresh</v-icon>
            </v-btn>
          </span>


        </v-card-title>
        <v-divider></v-divider>
        <v-tabs icons-and-text centered grow v-model="current_tab">
          <v-tabs-slider color="primary"></v-tabs-slider>

          <v-tab href="#tab-person">Betriebsprofil
            <v-icon>info_outline</v-icon>
          </v-tab>

          <v-tab href="#tab-premium" :disabled="!BetriebVorhanden">Premium Infos
            <v-icon>info</v-icon>
          </v-tab>

          <v-tab href="#tab-suchbegriffe" :disabled="!BetriebVorhanden">Suchbegriffe
            <v-icon>settings</v-icon>
          </v-tab>

          <v-tab href="#tab-skills" :disabled="!BetriebVorhanden">Inhalte
            <v-icon>work</v-icon>
          </v-tab>

          <!-- <v-tab href="#tab-ratings" :disabled="!BetriebVorhanden">Bewertungen
            <v-icon>star</v-icon>
          </v-tab> -->

          <v-tab href="#tab-darstellung" :disabled="!BetriebVorhanden">Darstellung
            <v-icon>picture_in_picture</v-icon>
          </v-tab>

          <v-tab href="#tab-impressum" :disabled="!BetriebVorhanden">Impressum
            <v-icon>lock</v-icon>
          </v-tab>

          <!--         <v-divider></v-divider> -->

          <v-tab-item value="tab-person" lazy>
            <profile v-on:busy="busy = $event" @tabswitch="switchTab('tab-premium')" :betrieb="this.company"></profile>
          </v-tab-item>

          <v-tab-item value="tab-premium" lazy>
            <premium v-on:busy="busy = $event" @tabswitch="switchTab('tab-suchbegriffe')" :betrieb="this.company"></premium>
          </v-tab-item>

          <v-tab-item value="tab-suchbegriffe" lazy>
            <suchbegriffe v-on:busy="busy = $event" @tabswitch="switchTab('tab-skills')" :betrieb="this.company" :leistungen="this.leistungen"></suchbegriffe>
          </v-tab-item>
          <v-tab-item value="tab-skills" lazy>
            <leistungen v-on:busy="busy = $event" @tabswitch="switchTab('tab-darstellung')" :betrieb="this.company" ></leistungen>
          </v-tab-item>

          <!-- <v-tab-item value="tab-ratings" lazy>
            <bewertungen v-on:busy="busy = $event" @tabswitch="switchTab('tab-darstellung')" :betrieb="this.company" ></bewertungen>
          </v-tab-item> -->

          <v-tab-item value="tab-darstellung" lazy>
            <darstellung v-on:busy="busy = $event" @tabswitch="switchTab('tab-impressum')" :betrieb="this.company"></darstellung>
          </v-tab-item>

          <v-tab-item value="tab-impressum" lazy>
            <impressum v-on:busy="busy = $event" @tabswitch="switchTab('tab-person')" :betrieb="this.company"></impressum>
          </v-tab-item>
        </v-tabs>
      </v-card>
      <!-- <v-btn @click="getMeinBetrieb()">recheck</v-btn> -->
    </v-flex>
  </v-layout>
</template>

<script>
import Profile from '~/pages/meinbetrieb/profile'
import Premium from '~/pages/meinbetrieb/premium'
import Leistungen from '~/pages/meinbetrieb/leistungen'
import Suchbegriffe from '~/pages/meinbetrieb/suchbegriffe'
import Darstellung from '~/pages/meinbetrieb/darstellung'
import Impressum from '~/pages/meinbetrieb/impressum'
import Bewertungen from '~/pages/meinbetrieb/bewertungen'
import axios from 'axios'

export default {
  components: {
    Profile,
    Premium,
    Leistungen,
    Suchbegriffe,
    Darstellung,
    Impressum,
    Bewertungen
  },
  data () {
    return {
      busy: true,
      checkbetrieb: false,
      data: [],
      loading: true,
      company: null,
      leistungen: '',
      current_tab: 'tab-person'
    }
  },
  created () {
    this.getMeinBetrieb()
    this.getMeineLeistungen()
  },
  mounted () {
    if (this.BetriebVorhanden) {
      if (this.company) {
        this.getMeinBetrieb()
      }
    }
  },
  computed: {
    BetriebVorhanden: function () {
      if (this.$store.getters.authBetrieb) {
        if (this.$store.getters.authBetrieb.name) return true
      } else return false
    }
  },
  methods: {
    switchTab: function (str) {
      this.current_tab = str
    },
    getMeinBetrieb: function () {
      const app = this
      axios
        .get('/api/v1/meinbetrieb')
        .then(function (resp) {
          app.company = resp.data
          app.busy = false
        })
        .catch(function (error) {
          console.log(error)
          console.log('Kein Betrieb verknüpft')
        })
    },
    async CheckBetrieb () {
      this.getMeinBetrieb()
      this.getMeineLeistungen()
      console.log('betriebscheck...')
      this.busy = true
      const data = await this.$store.dispatch('fetchUser')
      console.log(data)
      this.busy = false
    },

    getMeineLeistungen: function () {
      const app = this
      axios
        .get('/api/v1/meineleistung')
        .then(function (resp) {
          app.leistungen = resp.data
        })
        .catch(function (error) {
          // alert("Konnte Firma nicht laden")
          console.log(error)
        })
    }
  },
  metaInfo () {
    return { title: 'Betriebsprofil Ändern' }
  }
}
</script>

